import { presenceState } from '@databases/presence';
import { proxy, subscribe } from 'valtio';

import { telepointerColors } from '@canvas/constants/collaborator/telepointer';
import { AI_AGENT_USER } from '@canvas/model/identity';

type UIStreamingState = {
  entryIdSelectedForProcessing: string;
  fieldIdSelectedForProcessing: string;
  fieldsAreFinishedStreaming: boolean;
  processedValues: Set<string>;
  addProcessedValue: (fieldId: string, entryId: string) => void;
};

export const aiFirstCreationStreamingState = proxy<UIStreamingState>({
  entryIdSelectedForProcessing: '',
  fieldIdSelectedForProcessing: '',
  fieldsAreFinishedStreaming: false,
  processedValues: new Set<string>(),
  addProcessedValue(fieldId: string, entryId: string) {
    this.processedValues.add(`${fieldId}-${entryId}`);
  },
});

const ROVO_PARTICIPANT = {
  identity: { ...AI_AGENT_USER, displayName: 'Rovo' },
  colorToken: telepointerColors[0].telepointerColorToken, // this will be replaced by a gradient
};

// In test environments, Valtio may be mocked and
// "subscribe" will throw if passed a non-proxy. Wrap in try/catch so tests that mock Valtio don't crash.
try {
  subscribe(aiFirstCreationStreamingState as any, () => {
    const entryId = aiFirstCreationStreamingState.entryIdSelectedForProcessing;

    if (entryId) {
      presenceState.addParticipant(
        {
          entryId,
        },
        ROVO_PARTICIPANT
      );
    } else {
      presenceState.removeParticipant(ROVO_PARTICIPANT);
    }
  });
  // eslint-disable-next-line canvas/no-swallow-errors-in-catch, no-empty
} catch {}
